import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class Repeaterdetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-60 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
					<p>Are you a dedicated NEET or JEE aspirant aiming to secure admission in top-tier medical and engineering colleges? MIET Institute understands the journey of droppers like you and offers specialised courses tailored to your needs, ensuring your success in these competitive exams.</p><br/>
				  <h1 style={{fontSize: '30px'}}>Why Choose MIET Institute?</h1><br/>

				  <ul>
					<li><b>Experienced and Expert Faculty:</b> At MIET Institute, we pride ourselves on our team of seasoned faculty members who possess years of experience in guiding students towards exam success. With their in-depth knowledge and understanding of exam patterns, they provide unparalleled guidance to help you excel.</li>
					<li><b>Comprehensive Course Material:</b> Our meticulously crafted course material covers every aspect of the NEET and JEE syllabi, making complex topics easy to comprehend and retain. With our comprehensive resources, you can effectively revise and practice, enhancing your preparation.</li>
					<li><b>Personalized Learning Approach:</b> We recognize that every student is unique, with distinct strengths and weaknesses. That's why our courses are designed to cater to individual learning needs. Through personalized attention, we help you focus on areas that require improvement, maximizing your potential.</li>
					<li><b>Regular Assessment and Mock Tests:</b> Assessment is key to tracking your progress and identifying areas for enhancement. MIET Institute conducts regular assessments and mock tests, providing valuable insights into your performance and enabling targeted improvements.</li>
					<li><b>Doubt Resolution Sessions:</b> We understand the importance of clarifying doubts promptly. Our dedicated doubt resolution sessions offer you the opportunity to seek clarification on concepts, fostering a deeper understanding and boosting your confidence.</li>
					<li><b>Effective Time Management Strategies:</b> Success in NEET and JEE exams requires adept time management skills. MIET Institute equips you with proven strategies to optimize your time during exams, enhancing your speed and accuracy.
</li>
				  </ul>
                    </ScrollAnimation>	
                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
							<h1 style={{fontSize: '30px'}}>About MIET Institute</h1><br/>
							<p>MIET Institute is committed to empowering students to achieve their academic goals through comprehensive and effective coaching. With a legacy of excellence spanning years, we have nurtured countless aspirants, guiding them towards success in NEET, JEE, and other competitive exams.</p>
							<p>Our institute offers a range of courses, meticulously designed to cater to diverse learning needs. From foundation to advanced levels, we provide holistic preparation to ensure your success. Additionally, we offer scholarship opportunities to recognize and support talented students across the nation.</p>
					</div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
							<h1 style={{fontSize: '30px'}}>NEET Coaching @ MIET Institute</h1><br/>
							<p>With a proven track record of success, MIET Institute stands as a premier destination for NEET coaching. Our courses are designed to provide comprehensive preparation, enabling you to tackle the NEET exam with confidence. Join us to excel on your journey towards a fulfilling medical career.</p>
					</div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
							<h1 style={{fontSize: '30px'}}>JEE Coaching @ MIET Institute</h1><br/>
							<p>For aspiring engineers, MIET Institute offers unparalleled JEE coaching that equips you with the knowledge and skills to ace the exam. Our experienced faculty and comprehensive resources ensure that you're well-prepared to excel in the highly competitive world of engineering entrance exams.</p>
							<p>At MIET Institute, we are dedicated to nurturing talent and fostering academic excellence. Join us and let's embark on the path to success together!</p>
					</div>
					</ScrollAnimation>
                 
                  
				  </div>
		      </div>
			  <Sidebar />
		    </div>
		  </div>
		</div>

        }
}

export default Repeaterdetails;